const photos = [
  {
    alt: "Atelier réparation fenêtre Strasbourg",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/23eb1b95702aea6f23d59e6631489d05.jpeg",
  },
  {
    alt: "technicien quincaillerie fenêtre Bas-Rhin",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/a5678743fe9ccf4d4061d6534d54e38d.jpeg",
  },
  {
    alt: "intervention réparation fenêtre à domicile",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/ce40868f0334c840c1262eb6cbb1cf52.jpeg",
  },
  {
    alt: "pièces de quincaillerie fenêtre toutes marques",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/4f5ebbcb84a72fdd78cd48d354b38b1d.webp",
  },
];

export default function Gallery() {
  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="max-w-4xl">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-8 md:mb-10">
            Galerie photos
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {photos.map((photo, i) => (
            <div
              key={i}
              className="aspect-[4/3] rounded-2xl overflow-hidden border border-rose-200 bg-white"
            >
              <img
                src={photo.src}
                alt={photo.alt}
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}